module.exports = __webpack_public_path__ + "img/coverBg.d0cc2fcd.png";